<section id="screenshots" class="screenshot-area ptb-100">
    <div class="container-fluid">
        <div class="section-title">
            <h2> {{'appName' | translate}} </h2>
            <div class="bar"></div>
            <p> {{'someScreenshot' | translate}} </p>
        </div>

        <div class="screenshot-slider owl-carousel owl-theme">
            <div class="screenshot-item">
                <div class="image">
                    <img src="assets/img/screenshot/screen4.jpg" alt="image">
                </div>
            </div>
            <div class="screenshot-item">
                <div class="image">
                    <img src="assets/img/screenshot/screen1.jpg" alt="image">
                </div>
            </div>

            <div class="screenshot-item">
                <div class="image">
                    <img src="assets/img/screenshot/screen2.jpg" alt="image">
                </div>
            </div>
            <div class="screenshot-item">
                <div class="image">
                    <img src="assets/img/screenshot/screen3.jpg" alt="image">
                </div>
            </div>
            <div class="screenshot-item">
                <div class="image">
                    <img src="assets/img/screenshot/screen5.jpg" alt="image">
                </div>
            </div>
            <div class="screenshot-item">
                <div class="image">
                    <img src="assets/img/screenshot/screen6.jpg" alt="image">
                </div>
            </div>
            <div class="screenshot-item">
                <div class="image">
                    <img src="assets/img/screenshot/screen7.jpg" alt="image">
                </div>
            </div>
            <div class="screenshot-item">
                <div class="image">
                    <img src="assets/img/screenshot/screen8.jpg" alt="image">
                </div>
            </div>
            <div class="screenshot-item">
                <div class="image">
                    <img src="assets/img/screenshot/screen9.jpg" alt="image">
                </div>
            </div>
            <div class="screenshot-item">
                <div class="image">
                    <img src="assets/img/screenshot/screen10.jpg" alt="image">
                </div>
            </div>
            <div class="screenshot-item">
                <div class="image">
                    <img src="assets/img/screenshot/screen11.jpg" alt="image">
                </div>
            </div>
            <div class="screenshot-item">
                <div class="image">
                    <img src="assets/img/screenshot/screen12.jpg" alt="image">
                </div>
            </div>
            <div class="screenshot-item">
                <div class="image">
                    <img src="assets/img/screenshot/screen13.jpg" alt="image">
                </div>
            </div>
            <div class="screenshot-item">
                <div class="image">
                    <img src="assets/img/screenshot/screen14.jpg" alt="image">
                </div>
            </div>
            <div class="screenshot-item">
                <div class="image">
                    <img src="assets/img/screenshot/screen15.jpg" alt="image">
                </div>
            </div>
            <div class="screenshot-item">
                <div class="image">
                    <img src="assets/img/screenshot/screen16.jpg" alt="image">
                </div>
            </div>
            <div class="screenshot-item">
                <div class="image">
                    <img src="assets/img/screenshot/screen17.jpg" alt="image">
                </div>
            </div>
            <div class="screenshot-item">
                <div class="image">
                    <img src="assets/img/screenshot/screen18.jpg" alt="image">
                </div>
            </div>
            <div class="screenshot-item">
                <div class="image">
                    <img src="assets/img/screenshot/screen19.jpg" alt="image">
                </div>
            </div>
            <div class="screenshot-item">
                <div class="image">
                    <img src="assets/img/screenshot/screen20.jpg" alt="image">
                </div>
            </div>

        </div>
    </div>
</section>
